(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/react/carousel-slide.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/react/carousel-slide.js');

'use strict';

const {
  SQUARE,
  PORTRAIT
} = svs.components.tbUi.carousel.CarouselImageAspect;
const CarouselSlide = _ref => {
  let {
    actions,
    aspect,
    children,
    image,
    isSelected,
    title
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "image-wrapper ui-carousel-image ui-carousel-image-".concat(aspect.toLowerCase())
  }, React.createElement("picture", null, React.isValidElement(image) ? image : React.createElement("img", {
    alt: image.alt,
    className: "js-image image",
    decoding: "sync",
    itemProp: "image",
    src: image.src,
    title: image.title
  }))), React.createElement("div", {
    className: "ui-carousel-content"
  }, React.createElement("h2", {
    className: "h1 ui-carousel-title"
  }, title), React.createElement("div", {
    className: "ui-carousel-body"
  }, children), React.createElement("div", {
    className: "ui-carousel-actions ui-carousel-actions-".concat(actions.length)
  }, actions.map((_ref2, index) => {
    let {
      label,
      tracking,
      url
    } = _ref2;
    return React.createElement("a", {
      className: "btn btn-inverted btn-block",
      href: url
      ,
      key: "action-".concat(index),
      onClick: () => svs.components.analytics.trackEvent(tracking),
      tabIndex: isSelected ? 0 : -1,
      title: label
    }, React.createElement("span", {
      className: "btn-link-text"
    }, label));
  }))));
};
CarouselSlide.defaultProps = {
  actions: [],
  aspect: PORTRAIT,
  isSelected: false
};
setGlobal('svs.components.tbUi.carousel.CarouselSlide', CarouselSlide);

 })(window);